// Module
var code = "<select class=\"{{ vm.cssClass }}\" ng-model=\"vm.selectedLanguage\" ng-options=\"language as language.name for language in vm.languages\"> </select> ";
// Exports
module.exports = code;